import request from "@/utils/request"

//设置旋转角度
export function setImgAngle (data) {
    return request({
        url:'/file/scan/setRotateAngle',
        method: "post",
        data:data,
        noShowLoading: true,
    })
}


// 图片上传完成接口
export function finishUpload (data) {
    return request({
        url:'/file/scan/finishUpload',
        method: "post",
        data:data
    })
}

export function delImage (data) {
    return request({
        url:'/file/scan/delete',
        method: "post",
        data:data
    })
}